import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'flx-two-column-one-fifth',
	templateUrl: './two-column-one-fifth.component.html',
	styleUrls: ['./two-column-one-fifth.component.scss']
})
export class FLXTwoColumnOneFifthComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
